import { enableMapSet } from "immer";
import { create } from "zustand";
import { immer } from "zustand/middleware/immer";

import { createChatRoomActionsSlice } from "./slices/chatRooms/createChatRoomActionsSlice";
import { createChatRoomMessageActionsSlice } from "./slices/chatRooms/createChatRoomMessageActionsSlice";
import { createChatRoomsSlice } from "./slices/chatRooms/createChatRoomsSlice";
import { createCommunityInboxSlice } from "./slices/createCommunityInboxSlice";
import { createThreadsSlice } from "./slices/createThreadsSlice";
import { createUISlice } from "./slices/createUISlice";
import { createUnreadChatRoomsSlice } from "./slices/createUnreadChatRoomsSlice";
import type { ChatStoreState } from "./types";

enableMapSet();

export const useChatStore = create<ChatStoreState>()(
  immer((...a) => ({
    ...createChatRoomsSlice(...a),
    ...createChatRoomActionsSlice(...a),
    ...createChatRoomMessageActionsSlice(...a),
    ...createThreadsSlice(...a),
    ...createUnreadChatRoomsSlice(...a),
    ...createUISlice(...a),
    ...createCommunityInboxSlice(...a),
  })),
);
